import { BroadcastForm } from './components/BroadcastForm'

/** The notifications tab (X1): today, only the broadcast form. */
export function NotificationsTab() {
  return <BroadcastForm />
}
